
// Multiple Select: Multiple dropdown selection with checkbox and option group
//<div class="multiple-select" data - multiple - text="Multiple Requests" >
//    <select asp -for= "@Model.RequestTypes" asp - items= "@Model.RequestTypeSelects" multiple class="custom-select form-control-input-md" placeholder = "Request type" >
//        </select>
//< /div>
type option = {
    value: string,
    text: string,
    selected: boolean
}
type optionGroup = option & {
    options: option[]
}
export default class MultipleSelect {
    private optionsPanel: HTMLElement;
    private element: HTMLSelectElement;
    private altElement: HTMLInputElement;
    private optionGroups: optionGroup[] = [];
    constructor(private wrapper: HTMLElement) {
        this.element = this.wrapper.querySelector("select");
    }

    init = () => {
        // parse options
        this._parseOptions();
        // create dummy element
        this.altElement = this._createAltElement();
        // insert next to current element
        this.wrapper.appendChild(this.altElement);
        // hide original element
        this.element.classList.add("form-control-hidden");
        // render options
        this.optionsPanel = this._renderOptions();
        // events
        this._addEvents();
        // validate option groups
        this.optionsPanel.querySelectorAll<HTMLElement>(".multipe-select-option--group").forEach(group => {
            this._validateOptionGroupState(group);
        })
        // custom message
        this._validateCustomMessage();
    }
    _addEvents = () => {
        // open options panel
        this.altElement.addEventListener("click", (e) => {
            e.preventDefault();
            this.optionsPanel.classList.toggle("show");
        });
        // close options panel when clicking outside
        document.addEventListener("click", (e) => {
            const target = e.target as HTMLElement;
            if (!target.closest(".multiple-select-alt") && !target.closest(".multipe-select-options")) {
                this.optionsPanel.classList.toggle("show", false);
            }
        });
        // select
        this.optionsPanel.querySelectorAll(".multipe-select-option").forEach((element: HTMLElement) => {
            element.addEventListener("click", (e) => {
                e.preventDefault();
                this._onOptionClicked(element);
                //this._groupCheckHandler(element);
            });
        });
    }
    _onOptionClicked = (element: HTMLElement) => {
        // set checked state
        const checked = this._setCheckedState(element);

        // option group
        if (element.classList.contains("multipe-select-option--group")) {
            // toggle all
            this.optionsPanel.querySelectorAll<HTMLElement>(".multipe-select-option[data-group='" + element.dataset["value"] + "']").forEach(child => {
                this._setCheckedState(child, checked);
            });
        } else {
            // individual option
            const optionGroupElement = this.optionsPanel.querySelector<HTMLElement>(".multipe-select-option--group[data-value='" + element.dataset["group"] + "']")
            // validate option group state
            if (optionGroupElement) {
                this._validateOptionGroupState(optionGroupElement);
            }
        }

        this._validateCustomMessage();
    }
    _setCheckedState = (element: HTMLElement, checked?) => {
        // check alt option
        const input = element.querySelector<HTMLInputElement>("input");
        const currentState = input.checked;
        if (checked !== undefined) {
            input.checked = checked;
        } else {
            input.checked = !currentState;
        }

        // select origin option
        const optionElement = this.element.querySelector<HTMLOptionElement>("option[value='" + element.dataset["value"] + "']");
        if (optionElement)
            optionElement.selected = input.checked;
        return input.checked;
    }
    _validateOptionGroupState = (element: HTMLElement) => {
        // set state
        const input = element.querySelector<HTMLInputElement>("input");
        if (this.optionsPanel.querySelector<HTMLElement>(".multipe-select-option[data-group='" + element.dataset["value"] + "'] input:not(:checked)")) {
            input.checked = false;
        } else if (this.optionsPanel.querySelector<HTMLElement>(".multipe-select-option[data-group='" + element.dataset["value"] + "']")) {
            input.checked = true;
        }
    }
    _validateCustomMessage = () => {
        const customMessage = this.wrapper.dataset["multipleText"] || "Multiple";
        if (this.optionsPanel.querySelector<HTMLElement>(".multipe-select-option input:checked")) {
            this.altElement.value = customMessage;
        } else {
            this.altElement.value = "";
        }
    }
    _renderOptions = () => {
        const panel = document.createElement("div");
        panel.className = "multipe-select-options";

        this.optionGroups.forEach(optGroup => {
            // render option group
            panel.appendChild(this._renderOption(optGroup.value, optGroup.text, optGroup.selected, true));
            optGroup.options.forEach(opt => {
                // render option
                panel.appendChild(this._renderOption(opt.value, opt.text, opt.selected, false, optGroup.value));
            });
            // render divider
            panel.appendChild(this._renderDivider());
        });

        // insert next to alt element
        this.wrapper.appendChild(panel);
        return panel;
    }
    _renderOption = (value: string, text: string, selected: boolean, isGroup = false, groupId = "") => {
        const div = document.createElement("div");
        div.className = "multipe-select-option";
        div.setAttribute("data-value", value);
        if (isGroup) {
            div.classList.add("multipe-select-option--group");
        } else {
            div.setAttribute("data-group", groupId);
        }

        const customCheckbox = document.createElement("div");
        customCheckbox.classList.add("custom-control", "custom-checkbox");

        const input = document.createElement("input");
        input.type = "checkbox";
        input.classList.add("custom-control-input");
        if (selected) {
            input.checked = true;
        }

        const label = document.createElement("label");
        label.className = "custom-control-label";
        label.textContent = text;

        customCheckbox.appendChild(input);
        customCheckbox.appendChild(label);
        div.appendChild(customCheckbox);

        return div;

    }
    _renderDivider = () => {
        const div = document.createElement("div");
        div.className = "multipe-select-divider";
        return div;
    }
    _createAltElement = () => {
        const altElement = document.createElement("input");
        // Grab all of the original's attributes, and pass them to the replacement
        for (var i = 0, l = this.element.attributes.length; i < l; ++i) {
            var nodeName = this.element.attributes.item(i).nodeName;
            var nodeValue = this.element.attributes.item(i).nodeValue;

            altElement.setAttribute(nodeName, nodeValue);
        }
        altElement.classList.add("multiple-select-alt");
        altElement.readOnly = true;
        // clean up
        altElement.removeAttribute("name");
        altElement.removeAttribute("id");
        altElement.removeAttribute("multiple");
        altElement.classList.remove("multiple-select");
        return altElement;
    }
    _parseOptions = () => {
        this.element.childNodes.forEach((child: HTMLElement) => {
            if (child.tagName === 'OPTGROUP') {
                const optGroup = child as HTMLOptGroupElement;
                this.optionGroups.push({
                    text: optGroup.label,
                    value: optGroup.label,
                    selected: false,
                    options: this._getOptionsFromElement(optGroup)
                });
            } else if (child.tagName === 'OPTION') {
                const option = child as HTMLOptionElement;
                this.optionGroups.push({ text: option.text, value: option.value, selected: option.selected, options: [] });
            }
        });
    }
    _getOptionsFromElement = (element: HTMLElement): option[] => {
        return $(element).find(' > option').toArray().map((opt: HTMLOptionElement) => ({ value: opt.value, text: opt.text, selected: opt.selected }));
    }
}